module.exports = __webpack_public_path__ + "static/media/bgDefaultCoursesTabletNight.a6b17da6.jpg";